import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
  CkEditorFull,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";

import Filters from "./Filters";
import { GalleryFieldUrl } from "components/form";
// components

export default function Add(props) {
  const core = useCore();

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            _: " ",
            port: "EMAIL",
            body_email: ``,
            body_sms: "",
            filter_type: "without_filter",
          }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.date_from)
              values.date_from = dateTimeToserver(
                values.date_from,
                "YYYY-MM-DD"
              );
            if (values.date_to)
              values.date_to = dateTimeToserver(values.date_to, "YYYY-MM-DD");
            await props.submit(transformTranslateFromValues(values));
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="subject"
                    component={TextField}
                  />
                  <div>
                    <Field
                      placeholder="پورت"
                      label="پورت :"
                      name="port"
                      component={Select}
                      options={[
                        { value: "PAKAT", label: "پاکت" },
                        { value: "EMAIL", label: "ایمیل" },
                        { value: "SMS", label: "اس ام اس" },
                        {
                          value: "SMS&EMAILKP",
                          label: "sms & email (pakat,kavenegar)",
                        },
                        { value: "SANDBOXPAKAT", label: "سندباکس پاکت" },
                        { value: "SANDBOXMAIL", label: "سندباکس ایمیل" },
                        { value: "SANDBOXSMS", label: "سندباکس sms" },
                        { value: "SANDBOXSMSK", label: "سندباکس کاوه نگار" },
                      ]}
                    />
                  </div>

                  {(values.port == "EMAIL" ||
                    values.port == "SANDBOXMAIL" ||
                    values.port == "PAKAT" ||
                    values.port == "SANDBOXPAKAT" ||
                    values.port == "SMS&EMAILKP") && (
                    <>
                      {" "}
                      <Field
                        placeholder="گالری"
                        label="گالری :"
                        name="_"
                        component={GalleryFieldUrl}
                        dataType="url"
                      />
                      <Field
                        placeholder="بدنه"
                        label="بدنه :"
                        name="body_email"
                        component={CkEditorFull}
                      />
                    </>
                  )}
                  {(values.port == "SMS&EMAILKP" ||
                    values.port == "SMS" ||
                    values.port == "SANDBOXSMSK" ||
                    values.port == "SANDBOXSMS") && (
                    <Field
                      placeholder=" بدنه اس ام اس"
                      label="بدنه اس ام اس :"
                      name="body_sms"
                      component={TextArea}
                    />
                  )}

                  {(values.port == "SANDBOXSMS" ||
                    values.port == "SANDBOXMAIL" ||
                    values.port == "SANDBOXPAKAT" ||
                    values.port == "SANDBOXSMSK") && (
                    <Field
                      placeholder="دریافت کننده"
                      label="دریافت در :"
                      name="receiver"
                      component={TextField}
                    />
                  )}
                </div>
              </div>
              <hr className="my-12" />
              {((values.port != "SANDBOXSMS" && values.port != "SANDBOXMAIL") ||
                values.port == "SANDBOXPAKAT" ||
                values.port == "SMS&EMAILKP") && (
                <Filters values={values} setFieldValue={setFieldValue} />
              )}

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
